export const FilterIds = {
  State: 1,
  Origin: 2,
  PayCycle: 4,
  RetentionScore: 5,
  CustomerType: 6,
} as const;